/* Keepsake theme — interactions */
(function () {
  'use strict';

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* ---------- Mobile drawer ---------- */
  const drawer = $('[data-drawer]');
  const openBtn = $('[data-drawer-open]');
  if (drawer && openBtn) {
    const close = () => {
      drawer.removeAttribute('open-drawer');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      openBtn.focus();
    };
    openBtn.addEventListener('click', () => {
      drawer.setAttribute('open-drawer', '');
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      const first = $('a, button, summary', drawer.querySelector('.drawer__panel'));
      if (first) first.focus();
    });
    $$('[data-drawer-close]', drawer).forEach((el) => el.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.hasAttribute('open-drawer')) close();
    });
  }

  /* ---------- Search panel ---------- */
  const searchToggle = $('[data-search-toggle]');
  const searchPanel = $('#SearchPanel');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', () => {
      const willOpen = searchPanel.hasAttribute('hidden');
      searchPanel.toggleAttribute('hidden', !willOpen);
      searchToggle.setAttribute('aria-expanded', String(willOpen));
      if (willOpen) $('input[type="search"]', searchPanel).focus();
    });
  }

  /* ---------- Engraving preview ---------- */
  function fitEngraving(textEl, value) {
    const len = value.length;
    let size = 52;
    if (len > 3) size = 42;
    if (len > 6) size = 34;
    if (len > 9) size = 27;
    if (len > 14) size = 22;
    textEl.setAttribute('font-size', size);
    textEl.textContent = value;
    // Shrink further if the text would leave the disc (max width ~170 units)
    try {
      let guard = 0;
      while (textEl.getComputedTextLength() > 170 && size > 12 && guard < 30) {
        size -= 1;
        textEl.setAttribute('font-size', size);
        guard += 1;
      }
    } catch (e) { /* element not rendered yet */ }
  }

  $$('[data-engrave-input]').forEach((input) => {
    const scope = input.closest('[data-studio], .personalize__part');
    if (!scope) return;
    const textEl = $('[data-engrave-text]', scope);
    if (!textEl) return;
    const sample = textEl.textContent.trim();
    const update = () => fitEngraving(textEl, input.value.trim() || sample);
    input.addEventListener('input', update);
    update();
  });

  $$('[data-metal-button]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const scope = btn.closest('[data-studio]');
      if (!scope) return;
      $$('[data-metal-button]', scope).forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
      const pendant = $('[data-pendant]', scope);
      if (pendant) pendant.dataset.metal = btn.dataset.metal;
    });
  });

  /* ---------- Character counters ---------- */
  $$('[data-count-source]').forEach((field) => {
    const key = field.dataset.countSource;
    const out = $(`[data-count-for="${key}"]`);
    const max = parseInt(field.getAttribute('maxlength'), 10);
    if (!out || !max) return;
    const update = () => { out.textContent = Math.max(0, max - field.value.length); };
    field.addEventListener('input', update);
    update();
  });

  /* ---------- Message card builder ---------- */
  $$('[data-card-builder]').forEach((builder) => {
    const preview = $('[data-card-preview]', builder);
    if (!preview) return;
    const outs = {};
    $$('[data-card-out]', preview).forEach((el) => {
      outs[el.dataset.cardOut] = { el, fallback: el.textContent };
    });
    $$('[data-card-in]', builder).forEach((input) => {
      const key = input.dataset.cardIn;
      const update = () => {
        const target = outs[key];
        if (!target) return;
        let value = input.value.trim();
        if (key === 'to' && value) value = 'To ' + value;
        if (key === 'from' && value) value = 'Love, ' + value;
        target.el.textContent = value || target.fallback;
      };
      input.addEventListener('input', update);
      update();
    });

    const styleInput = $('[data-card-style-input]', builder);
    $$('[data-card-style]', builder).forEach((btn) => {
      btn.addEventListener('click', () => {
        $$('[data-card-style]', builder).forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
        preview.dataset.style = btn.dataset.cardStyle;
        if (styleInput) styleInput.value = btn.textContent.trim();
      });
    });

    const message = $('[data-card-in="message"]', builder);
    $$('[data-card-idea]', builder).forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!message) return;
        message.value = btn.dataset.cardIdea.slice(0, parseInt(message.getAttribute('maxlength'), 10) || 400);
        message.dispatchEvent(new Event('input', { bubbles: true }));
        message.focus();
      });
    });
  });

  /* ---------- Product: variants, gallery, quantity ---------- */
  $$('[data-product-section]').forEach((section) => {
    const jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    let product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    const idInput = $('[data-variant-id]', section);
    const addBtn = $('[data-add-button]', section);
    const addLabel = $('[data-add-label]', section);
    const priceWrap = $('[data-price-wrap]', section);
    const mainImg = $('.js-gallery-main', section);
    const pendant = $('[data-pendant]', section);
    const labels = { add: addLabel ? addLabel.textContent.trim() : 'Add to bag' };

    const metalOptionIndex = (product.options || []).findIndex((name) => /metal|colou?r|finish/i.test(name));

    function selectedOptions() {
      return $$('[data-option-index]', section).map((fs) => {
        const checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }

    function setMainImage(src) {
      if (!mainImg || !src) return;
      mainImg.removeAttribute('srcset');
      mainImg.src = src;
    }

    function updateMetal(options) {
      if (!pendant || metalOptionIndex < 0) return;
      const value = (options[metalOptionIndex] || '').toLowerCase();
      pendant.dataset.metal = /silver|steel|white|platinum/.test(value) ? 'silver' : 'gold';
    }

    function onChange() {
      const options = selectedOptions();
      $$('[data-option-index]', section).forEach((fs, i) => {
        const label = $('[data-option-selected]', fs);
        if (label) label.textContent = options[i] || '';
      });
      updateMetal(options);
      const variant = product.variants.find((v) => v.options.every((val, i) => val === options[i]));
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = window.KS_STRINGS ? window.KS_STRINGS.unavailable : 'Unavailable';
        return;
      }
      idInput.value = variant.id;
      if (addBtn) addBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? labels.add : (window.KS_STRINGS ? window.KS_STRINGS.soldOut : 'Sold out');
      if (variant.featured_image && variant.featured_image.src) setMainImage(variant.featured_image.src);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      // Re-render the price with the store's own money format
      if (priceWrap) {
        const sectionId = section.dataset.sectionId;
        fetch(`${window.location.pathname}?variant=${variant.id}&section_id=${sectionId}`)
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fresh = doc.querySelector('[data-price-wrap]');
            if (fresh) priceWrap.innerHTML = fresh.innerHTML;
          })
          .catch(() => {});
      }
    }

    $$('[data-option-input]', section).forEach((input) => input.addEventListener('change', onChange));

    $$('[data-thumb]', section).forEach((thumb) => {
      thumb.addEventListener('click', () => {
        $$('[data-thumb]', section).forEach((t) => t.removeAttribute('aria-current'));
        thumb.setAttribute('aria-current', 'true');
        setMainImage(thumb.dataset.src);
      });
    });

    $$('[data-qty]', section).forEach((btn) => {
      btn.addEventListener('click', () => {
        const input = $('input[name="quantity"]', section);
        const next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qty, 10));
        input.value = next;
      });
    });
  });

  /* ---------- Collection filters & sort ---------- */
  $$('[data-filter-form]').forEach((form) => {
    form.addEventListener('change', (e) => {
      if (e.target.matches('input[type="checkbox"], [data-autosubmit]')) form.submit();
    });
  });

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach((el) => {
    if (el.children.length && el.querySelector('.product-grid')) return;
    fetch(el.dataset.url)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
        else el.remove();
      })
      .catch(() => {});
  });
})();
